import { render, staticRenderFns } from "./jurisdictionForm.vue?vue&type=template&id=e50538ce&"
import script from "./jurisdictionForm.vue?vue&type=script&lang=js&"
export * from "./jurisdictionForm.vue?vue&type=script&lang=js&"
import style0 from "./jurisdictionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports